import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from '../../redux/internal';

export const AuthVerify = () => {
  const { token, decodedToken } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  const tokenCheckInterval = Number(process.env.REACT_APP_TOKEN_CHECK_INTERVAL);

  const isExpired = useCallback(() => {
    if (token && decodedToken.exp) {
      if (Date.now() / 1000 > decodedToken.exp) {
        return true;
      }
    }

    return false;
  }, [decodedToken.exp, token]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isExpired()) {
        navigate('/logout');
      }
    }, tokenCheckInterval);

    return () => clearInterval(interval);
  }, [isExpired, navigate, tokenCheckInterval]);

  return <></>;
};
